import { StrictMode } from 'react'
import ReactDOM from 'react-dom'
import styled from '@emotion/styled'
import { App } from './presentation/Router'
import { SentryWrapper } from './sentry'

import { theme } from './theme/theme'
import { ChakraProvider } from '@chakra-ui/react'

import { HelmetProvider } from 'react-helmet-async'

const DefaultStyle = styled.div`
  color: ${theme.colors.brand.text.main};
`

ReactDOM.render(
  <StrictMode>
    <SentryWrapper>
      <ChakraProvider theme={theme}>
        <HelmetProvider>
          <DefaultStyle>
            <App />
          </DefaultStyle>
        </HelmetProvider>
      </ChakraProvider>
    </SentryWrapper>
  </StrictMode>,
  document.getElementById('root')
)
